import { DefaultRouteReuseStrategy } from './default-reuse.strategy';

export class NoReuseStrategy extends DefaultRouteReuseStrategy {
    override shouldReuseRoute(): boolean {
        return false;
    }
}
